<template>
  <section>
    <!-- type： 1 - 悬浮弹框， 2 - 底部弹窗， 3 - 登陆 Toast -->
    <template v-if="type === 3">
      <div
        :class="[
          'login-tip',
          displayModeClassName,
          isLogin ? 'isLoggedIn' : '',
        ]"
        :style="{ display: displayToast }"
      >
        {{ config.title }}
      </div>
    </template>
    <template v-else>
      <van-popup
        v-model="showPopup"
        :round="type === 2"
        :position="type === 1 ? 'center' : 'bottom'"
        :close-on-click-overlay="isCloseable"
        :class="[
          type === 1 ? 'center' : 'bottom',
          'popup-wrapper',
          displayModeClassName,
          !config.title && !config.popupsDesc ? 'only-image' : '',
        ]"
        :closeable="isCloseable"
        @closed="close"
      >
        <p class="title">{{ config.title }}</p>
        <p class="desc">{{ config.popupsDesc }}</p>
        <van-image
          v-if="type === 1 && !!config.imgUrl"
          class="popup-image"
          :src="config.imgUrl"
        />
        <div :class="['confirm-btn']" @click="() => handleClickButton(config)">
          {{ config.buttonDesc || $t('common.close') }}{{ showCountText }}
        </div>
      </van-popup>
    </template>

    <levitated-sphere
      :showBox="showBox"
      :showRedTip="showRedTip"
      v-on:displayPopup="displayPopup"
      :id="config.id"
    />
  </section>
</template>

<script>
  import { getCloudControlPopups } from '@/api/cloud-control'
  import { mapState, mapGetters } from 'vuex'
  import Vue from 'vue'
  import { Toast } from 'vant'
  import LevitatedSphere from '@/components/LevitatedSphere'
  import bus from '@/utils/bus'
  import { getCookie } from '@/utils/tool'
  import {
    trackToastShow,
    trackBottomDialogShow,
    trackBottomDialogClick,
    trackPopupShow,
    trackPopupClick,
  } from './firebase.js'
  import { toplupeToken } from '@/utils/login'
  import { queryOrder as queryOrderNoLogin } from '@/api/order'
  import { getQuery, _getBoundingClientRect } from '@/utils/utils'
  import { isMsaWebView } from '@/utils/msa'
  import { jumpToPage } from '@/utils/utils'

  Vue.use(Toast)
  export default {
    name: 'cloud-control-popup',
    components: {
      LevitatedSphere,
    },
    data() {
      return {
        showPopup: false,
        type: 1,
        config: {},
        romoteConfigDatas: null,
        isCloseable: true,
        displayToast: 'none',
        showBox: false,
        showRedTip: false,
        tipInfo: '', //记录当页悬浮图标红点是否展示过的缓存信息
        count: 5,
        showCountdown: false, // 是否展示倒计时
        openFromFloatBox: false, // 记录弹窗的打开是否源于点击悬浮图标，用于打点区分触发时机
        isLogin: false,
      }
    },
    computed: {
      ...mapState(['gameName', 'region', 'userInfo']),
      ...mapGetters(['displayModeClassName']),
      showCountText() {
        if (this.showCountdown && this.config.showTime !== 1) {
          return '（0' + this.count + 's）'
        } else {
          return ''
        }
      },
      clickedBox() {
        // const val =
        //   sessionStorage.getItem(`${this.gameName}_showRedTip`) || this.tipInfo
        const val = this.tipInfo
        const game = val.split(',')[0]
        const showRedTip = val.split(',')[1]
        return game === this.gameName && showRedTip === 'yes'
      },
    },
    watch: {
      showPopup: function (val) {
        this.displayToast = val ? 'block' : 'none'
        this.showBox = this.type === 1 && !val
        if (this.type === 1 && !val) {
          // window.console.log('剩余展示时长：',this.count, ' s')
          this.showBox = true
          if (this.clickedBox || this.count === 0) {
            this.showRedTip = false
          } else {
            // 悬浮窗展示时间不满5s
            this.showRedTip = true
          }
        }
        if (val) {
          // 弹窗曝光埋点
          const params = {
            page: this.gameName,
            assignment_id: this.config.id,
          }
          this.type === 1 && trackPopupShow(params)
          this.type === 2 && trackBottomDialogShow(params)
          this.type === 3 && trackToastShow(params)
        }
      },
      displayToast: function (val) {
        // 如果配置了Toast为“一直展示可关闭”
        // 那就设置定时关闭弹窗
        if (this.type === 3 && val === 'block') {
          this.$nextTick(function () {
            const header = document.querySelector(
              '.detail-page-header.pc-header'
            )
            const toastDOM_PC = document.querySelector(
              '.login-tip.display-desktop'
            )
            if (header && toastDOM_PC) {
              const { top, left } = _getBoundingClientRect(header)
              toastDOM_PC.style.top = top + 60 + 'PX'
              toastDOM_PC.style.right = left - 7 + 'PX'
            }
          })

          const { showTime } = this.config
          if (showTime * 1 < 3) {
            setTimeout(() => {
              this.displayToast = 'none'
              this.showPopup = false
            }, 3000)
          }
        }
      },
      userInfo: function (val) {
        this.isLogin = !!(getCookie(toplupeToken) && val && val.kicoinId)
      },
    },
    created() {
      if (!process.client) return

      const self = this
      bus.$on('login success', () => {
        self.getConfigInfo(2)
      })
    },
    async mounted() {
      // msa屏蔽云控弹窗
      if (isMsaWebView()) return
      const isUserFromPayPage = Boolean(
        sessionStorage.getItem('isFromPayPage') === 'true' ||
          (await this.getOrderInfos())
      )
      if (isUserFromPayPage) {
        this.getConfigInfo(3) // 支付完成返回页面时展示弹窗
      } else {
        this.getConfigInfo(1) // 用户进入页面后就展示弹窗
      }
      if (this.displayModeClassName === 'display-desktop') {
        window.addEventListener('resize', this.handleResizeWindow)
      }
      bus.$on('autoLogin', () => {
        this.isLogin = true
      })
    },
    beforeDestroy() {
      bus.$off('login success')
    },
    destroyed() {
      if (this.displayModeClassName === 'display-desktop') {
        window.removeEventListener('resize', this.handleResizeWindow)
      }
    },
    methods: {
      handleResizeWindow() {
        const toastDOM = document.querySelector('.login-tip.display-desktop')
        const header = document.querySelector('.detail-page-header.pc-header')
        if (header && toastDOM) {
          const { left } = _getBoundingClientRect(header)
          toastDOM.style.right = left - 7 + 'PX'
        }
      },
      close() {
        this.$emit('closeTips')
      },
      handleClickButton(configData) {
        const { buttonOperation, landUrl, id } = configData
        // 弹窗按钮点击埋点
        const params = {
          page: this.gameName,
          assignment_id: id,
        }
        this.type === 1 && trackPopupClick(params)
        this.type === 2 && trackBottomDialogClick(params)
        /* 按钮文案: 2: “登陆”, 3:“下载” */
        if (buttonOperation * 1 === 1) {
          if (landUrl) {
            // 如果配置了要跳转的url，则直接跳转
            this.showPopup = false
            jumpToPage(landUrl)
          } else {
            Toast.fail('Something wrong :(')
          }
          return
        } else if (buttonOperation * 1 === 2) {
          this.showPopup = false
          // 判断用户是否登录，快速登陆接口
          if (this.isLogin) {
            return
          } else {
            bus.$emit('login')
          }
        } else if (buttonOperation * 1 === 3) {
          /* // 下载按钮点击埋点
          if(this.openFromFloatBox) {
            clickDownloadPopupBtn({
              scene: 4,
              page: this.gameName
            })
          }else {
            clickDownloadPopupBtn({
              scene: opportunity,
              page: this.gameName
            })
          } */
          // 静默下载 APP
          window.console.log('······静默下载app')
          // deeplink.init({
          //   pageName: 'themes',
          //   downloadAppUrl: downloadAppLink,
          //   success() {
          //     window.console.log('detail deeplink success')
          //   },
          //   fail() {
          //     window.console.log('detail deeplink fail')
          //   },
          // })
          this.showPopup = false
        } else if (buttonOperation * 1 === 4) {
          // 直接关闭弹窗
          this.showPopup = false
        }
      },
      getConfigInfo(callType) {
        return new Promise((resolve, reject) => {
          const self = this
          async function getConfigDatas() {
            if (callType === 1 && self.romoteConfigDatas) {
              return self.romoteConfigDatas || {}
            } else {
              try {
                const romoteDatas = await getCloudControlPopups({
                  game: self.gameName,
                  country: self.region,
                  opportunity: callType,
                })
                self.romoteConfigDatas = romoteDatas
                return romoteDatas
              } catch (e) {
                reject(e)
              }
            }
          }
          getConfigDatas().then((res) => {
            if (res && Object.keys(res).length > 0) {
              this.config = res
              const {
                isShow,
                type,
                showTime,
                floatPriority,
                title,
                popupsDesc,
                imgUrl,
              } = res
              if (isShow) {
                return resolve(false)
              }
              if (!isShow && type === 1 && floatPriority === 1) {
                // isShow 0：弹窗  1：不弹窗
                // 页面访问时，先展示悬浮图标，不弹窗，让用户主动点击悬浮图标再弹。
                this.showPopup = false
                this.showBox = true
              } else if (!title && !popupsDesc && !imgUrl) {
                // 标题和描述文案都未配置时会触发展示纯图的悬浮弹窗，
                // 防止后台未配置图片链接的情况，这会触发遮罩层但无内容展示
                this.showPopup = false
                this.showBox = false
                window.console.log(
                  '返回展示纯图的悬浮弹窗，但未配置图片... showPopup:',
                  this.showPopup
                )
                return resolve(false)
              } else {
                this.showPopup = !isShow
              }
              this.type = type
              this.openFromFloatBox = false // 恢复标记，此时触发弹窗为云控下发，并非点击悬浮图标
              /* // 下载弹窗曝光埋点
              if(buttonOperation*1 === 3) {
                const params = {
                  scene: callType,
                  page: this.gameName
                }
                showDownloadPopup(params)
              } */
              resolve(this.handleShowTime(showTime))
            } else {
              resolve(false)
            }
          })
        }).catch((e) => {
          window.console.log('云控弹窗 getConfigDatas ~~~~~ promise catch', e)
        })
      },
      handleShowTime(showTime) {
        /*  1：一直展示，可关闭； 2：一直展示，5s后可关闭；3：展示5s后，自动关闭； */
        const self = this
        if (showTime === 1) {
          this.isCloseable = true
          this.showCountdown = false
        } else if (showTime === 2) {
          this.isCloseable = false
          this.showCountdown = true
          this.countdownTimer(() => {
            self.isCloseable = true
            self.showCountdown = false
          }, 5)
        } else if (showTime === 3) {
          this.isCloseable = true
          this.showCountdown = true
          this.countdownTimer(() => {
            if (!this.openFromFloatBox) {
              // 该条件判断是为了防止出现以下状况：
              // 用户在 5s 展示期间手动关闭弹窗，在倒计时还未清零前又手动点击悬浮图标打开了弹窗，一旦倒计时清零弹窗就会自动关闭。
              self.showPopup = false
            }
          }, 5)
        }
        return true
      },
      countdownTimer(cb, TIME_COUNT) {
        let timer = null
        if (!timer) {
          this.count = TIME_COUNT
          timer = setInterval(() => {
            if (this.count > 0 && this.count <= TIME_COUNT) {
              --this.count
            } else {
              cb()
              clearInterval(timer)
              timer = null
            }
          }, 1000)
        }
      },
      displayPopup(val) {
        // 点击悬浮图标打开悬浮弹窗
        this.type = val
        this.showPopup = true
        this.showCountdown = false
        this.handleShowTime(1)
        // const cacheKey = this.config.game + '_showRedTip'
        // sessionStorage.setItem(cacheKey, this.config.game + ',yes')
        this.tipInfo = this.config.game + ',yes'
        /* 打点 */
        this.openFromFloatBox = true // 标记弹窗触发时机为点击悬浮球调起
        /* const { buttonOperation, opportunity} = this.config
        if(buttonOperation*1 === 3) {
          // 点击下载类型的悬浮球埋点
          showDownloadFloat({
            scene: opportunity, // 悬浮球来源:弹窗触发时机
            page: this.gameName
          })
          // 下载弹窗曝光埋点
          showDownloadPopup({
            scene: 4, // 点击悬浮球调起
            page: this.gameName
          })
        } */
      },
      // 查询用户订单状态，orderStatus = 10 表示支付成功
      async getOrderInfos() {
        const orderNo = getQuery('orderNo')
        if (!orderNo) {
          return false
        }
        const res = await queryOrderNoLogin({ orderNo: orderNo })
        const { orderStatus } = res || {}
        return orderStatus * 1 === 10
      },
    },
  }
</script>
<style lang="scss">
  .popup-wrapper {
    height: auto;
    padding: 40px 72px 60px;
    box-sizing: border-box;
    // background: #fff;

    .title {
      text-align: center;
      font-size: 54px;
      line-height: 72px;
      margin-bottom: 30px;
      box-sizing: border-box;
      word-break: break-all;
      width: 92%;
      margin-left: 4%;
      /* 若要限制标题行数可用以下代码 */
      // display: -webkit-box;
      // -webkit-box-orient: vertical;
      // -webkit-line-clamp: 3;
      // text-overflow: ellipsis;
      // max-height: 220px;
      // overflow: hidden;
    }
    .desc {
      font-size: 36px;
      line-height: 50px;
      margin-bottom: 50px;
      word-break: break-all;
    }
    .popup-image {
      width: 100%;
      border-radius: 12px;
    }
    .confirm-btn {
      margin: 60px auto 0;
      background-color: #f96000;
      color: #fff;
      width: 100%;
      height: 150px;
      line-height: 150px;
      text-align: center;
      border-radius: 104px;
      font-size: 48px;

      &.disabled-btn {
        opacity: 0.4;
      }
    }
    &.center {
      width: 984px;
      border-radius: 6px;
      box-shadow: 0px 0px 10px #ffffff;
    }
    &.bottom {
      width: 100%;
    }
  }

  /* 弹窗仅展示图片 */
  .van-popup.popup-wrapper.only-image {
    padding: 0;
    overflow: hidden;
    .title {
      margin-bottom: 0;
    }
    .desc {
      margin-bottom: 0;
    }
    .van-image.popup-image {
      height: 100%;
      font-size: 0;
      img {
        margin-bottom: -5px;
        vertical-align: bottom;
      }
    }
    .confirm-btn {
      display: none;
    }

    .van-popup__close-icon {
      font-size: 26px;
    }
  }

  /* 适配 GT */
  .van-popup.popup-wrapper.display-game-turbo {
    border-radius: 10px;
    .confirm-btn {
      margin-top: 20px;
    }
    .van-image.popup-image {
      img {
        max-height: 200px;
        object-fit: contain;
      }
    }
    &.only-image {
      width: auto;
      height: auto;
      .van-image.popup-image {
        img {
          max-height: max-content;
        }
      }
    }
  }

  /* 适配 PC */
  .van-popup.popup-wrapper.display-desktop {
    max-width: 360px;
    padding-right: 20px;
    padding-left: 20px;
    padding-top: 20px;
    padding-bottom: 20px;
    .title {
      font-size: 20px;
      line-height: 28px;
      margin-bottom: 10px;
      margin-top: 10px;
    }
    .desc {
      font-size: 16px;
      line-height: 26px;
      margin-bottom: 10px;
    }
    .confirm-btn {
      margin-top: 15px;
      height: 50px;
      font-size: 18px;
      line-height: 50px;
    }

    &.van-popup--bottom {
      left: 50%;
      transform: translateX(-50%);
    }

    &.only-image {
      padding: 0;
      .title,
      .desc {
        font-size: 0;
        margin-bottom: 0;
        margin-top: 0;
      }
    }
  }

  .login-tip {
    position: absolute;
    z-index: 999;
    margin-left: 75px;
    padding: 38px 50px;
    right: 93px;
    top: 160px;
    background: #f9a400;
    border-radius: 36px;
    color: #fff;
    font: 800 39px/53px Manrope-Medium;
    &::after {
      content: '';
      position: absolute;
      z-index: 999;
      width: 44px;
      height: 44px;
      right: 60px;
      top: -10px;
      background: #f9a400;
      border-radius: 6px;
      transform: rotate(45deg);
    }
    &.isLoggedIn {
      right: 15px;

      &::after {
        right: 40px;
      }
    }

    &.display-desktop {
      max-width: 400px;
      font-size: 16px;
      line-height: 24px;
      position: fixed;
      right: 45px;
      top: 60px;
      margin-left: 75px;
      padding: 10px 25px;
      border-radius: 10px;
      &:after {
        content: '';
        width: 10px;
        height: 10px;
        right: 20px;
        top: -4px;
        border-radius: 2px;
      }
    }
  }
</style>
